import script from "./MeetingRoomGuestTip.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingRoomGuestTip.vue?vue&type=script&setup=true&lang=ts"

import "./MeetingRoomGuestTip.vue?vue&type=style&index=0&id=23fda6c6&scoped=true&lang=scss"

import exportComponent from "/Users/zhangjun/Desktop/project/envo-landing-page/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23fda6c6"]])

export default __exports__